import React, { useState, useEffect } from "react";
import DropdownList from "react-widgets/DropdownList";
import "react-widgets/scss/styles.scss";

const SelectBox = (props) => {
  const [value, setValue] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const { input, inputvalue, options, inputnaam } = props;

    // Waarde zetten
    if (input?.value) {
      if (typeof input.value === "string") {
        setValue(input.value);
      } else if (typeof input.value === "object" && inputvalue in input.value) {
        setValue(input.value[inputnaam]);
      }
    }

    // Opties bijwerken
    if (options) {
      setOptions(options);
    }
  }, [props.input?.value, props.options, props.inputvalue]);

  const handleSelect = (value) => {
    const newValue = value[props.inputvalue];
    setValue(newValue);
    props.input.onChange(newValue);
  };

  const {
    label,
    meta: { error, touched, warning },
  } = props;
  if (label) {
    return (
      <div>
        <label>{label}</label>
        <div>
          <DropdownList dataKey={props.inputvalue} textField={props.inputnaam} data={options} onChange={handleSelect} value={value} filter="contains" />
          {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <DropdownList dataKey={props.inputvalue} textField={props.inputnaam} data={options} onChange={handleSelect} value={value} filter="contains" />
        {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    );
  }
};
export default SelectBox;
